<template>
  <el-card class="w-100 center">
    <div slot="header" class="cf">
      <span class="f5 fw6">Sign in</span>
      <router-link :to="{ name: 'reset_password' }" class="fr f6 link blue hover-hot-pink">Forgotten password?</router-link>
    </div>

    <el-alert v-if="authError" type="error" :title="authError" show-icon @close="closeAlert()"></el-alert>

    <el-form :model="user" :rules="rules" ref="form" @submit.native.prevent="submit()">
      <el-form-item label="Email" prop="email">
        <el-input type="email" v-model="user.email"></el-input>
      </el-form-item>
      <el-form-item label="Password" prop="password">
        <el-input type="password" v-model="user.password"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" native-type="submit">Sign in</el-button>
      </el-form-item>
    </el-form>
  </el-card>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  data() {
    return {
      user: {},
      rules: {
        email: [
          { required: true, type: 'email', trigger: 'blur' }
        ],
        password: [
          { required: true, trigger: 'blur' }
        ]
      }
    }
  },

  computed: {
    ...mapState('auth', ['authError'])
  },

  methods: {
    ...mapActions('auth', ['login']),

    submit() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          const user = _.pickBy(this.user, (v,k) => _.includes(['email', 'password'], k))
          this.login(user)
            .then(() => window.location.assign('/app'))
            .catch(() => false)
        } else {
          return false;
        }
      })
    },
    
    closeAlert() {
      this.$store.commit('auth/AUTH_ERROR', null)
    }
  }
}
</script>

<style lang="scss" scoped>
.el-card__header .link {
  margin-top: 2px;
}
</style>